import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'src/app/app.config';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { UserService } from 'src/app/shared-service/services/user.service';
declare var $:any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  plan_price:number = 149;
  plan_for:any;
  subsBtn:Boolean = false;
  is_buy:number = 0;
  plans:any;
  isloader:boolean = false;
  plan_id:any;
  discount:number = 0;
  userData:any;
  couponApplied = false;
  couponDiscountAmount = '';
  coupon = '';

  linkToAllow = '';
  playstoreLink =  '';
  phoneNo = '';
  whatsappNo='';
  phoneNo_1 = '';
  whatsappNo_1='';
  address =  [];
  emailId = '';
  isdCode = '';
  domain = '';
  copyRightYear = '';
  facebookUrl = '';
  linkedInUrl = '';
  youtubeUrl = '';
  twitterUrl = '';
  instagramUrl = '';
  telegramUrl = '';
  footerDescription = '';
  imgWidth = '';
  imgHeight = '';
  logo='';

  contactUsData:any;
  contactUsForm: FormGroup;
  submitted = false;
  regBtn:boolean = false;
  contactUs_message:any;
  isMsg:boolean = true;
  whatsappCountryIsd='';

  coursesList=[];
  branchesList=[];

  constructor(
    private quizService: QuizService,   private userService: UserService,  private formBuilder: FormBuilder,private config: AppConfig
  ) {
    this.linkToAllow = this.config.getConfig('MODULES_TO_ALLOW_BEFORE_LOGIN');
    this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
    this.phoneNo =  this.config.getConfig('PHONE_NO');
    this.whatsappNo = this.config.getConfig('WHATSAPP_NO');
    this.phoneNo_1 =  this.config.getConfig('PHONE_NO_1');
    this.whatsappNo_1 = this.config.getConfig('WHATSAPP_NO_1');
    this.address =  this.config.getConfig('ADDRESS');
    this.emailId =  this.config.getConfig('EMAIL_ID');
    this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
    this.domain = this.config.getConfig('DOMAIN');
    this.copyRightYear = this.config.getConfig('COPY_RIGHT_YEAR');
    this.facebookUrl = this.config.getConfig('FACEBOOK_LINK');
    this.linkedInUrl = this.config.getConfig('LINKEDIN_LINK');
    this.youtubeUrl = this.config.getConfig('YOUTUBE_LINK');
    this.twitterUrl = this.config.getConfig('TWITTER_LINK');
    this.instagramUrl =  this.config.getConfig('INSTAGRAM_LINK');
    this.telegramUrl = this.config.getConfig('TELEGRAM_LINK');
    this.footerDescription = this.config.getConfig('FOOTER_DESCRIPTION');
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.logo = this.config.getConfig('LOGO');
    this.whatsappCountryIsd = this.isdCode.replace(/\+/g,'');
  }

  ngOnInit() {
    if(localStorage.getItem('affiliate_code')){
      this.discount = 1;
    }
    $("#subscribe_course").on("hidden.bs.modal", function () {
      $('.coupon_msg').removeClass('success');
      $('.coupon_msg').removeClass('failure');
      this.coupon = '';
      this.couponApplied = false;
      this.couponDiscountAmount = '';
     });
    if(localStorage.getItem('closePromotionModal') != 'true'){
      this.getPlans();
    }else{
    }

    this.contactUsForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)] ],
      course: ['', [Validators.required]],
      branches: [''],
      subject: ['', [Validators.required]],
      message: [''],
    });

    this.branchesList= [
      {
        id: 'Vadodara',
        name:'Vadodara'
      },
      {
        id: 'Surat',
        name:'Surat'
      },
      {
        id: 'Kadodara',
        name:'Kadodara'
      },
      {
        id: 'Ahmedabad',
        name:'Ahmedabad'
      }
    ];

  }

  get f() { return this.contactUsForm.controls; }


  getPlans(){
    this.quizService.getPlansData().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.plan_id = res.data[0].subscription_id;
          this.plans = res.data;
          this.plan_price = res.data[0].amount;
        }
      }
    );
  }
  applyCoupon() {
    let data = {
      userId: this.userData.user_id,
      coupon_code: this.coupon,
      subscription_id: this.plan_id
    }
    this.quizService.couponCodeValidate(data).subscribe((result:any) => {
      if(result && result.data) {
        $('.coupon_msg').show();
        $('.coupon_msg').removeClass('failure');
        $('.coupon_msg').addClass('success');
        $('.coupon_msg').text( 'Coupon Applied Successfully' );
        this.plan_price = result.data[0].payable_amount;
        this.couponDiscountAmount =result.data[0].payable_amount + '';
        this.couponApplied = true;
        setTimeout(()=> {
          $('.coupon_msg').hide();
        }, 5000);
      } else {
        $('.coupon_msg').show();
        $('.coupon_msg').removeClass('success');
        $('.coupon_msg').addClass('failure');
        $('.coupon_msg').text(result.msg);
        this.couponApplied = false;
        setTimeout(()=> {
          $('.coupon_msg').hide();
        }, 5000);
      }
    });
  }

  setPlan(pid, price, plan_for){
    this.plan_price = price;
    this.plan_for = plan_for;
    this.plan_id = pid;
    this.coupon = '';
    this.couponApplied = false;
  }

  subscribe(){
    let curr_url = 'all-series/25/buy';
    localStorage.setItem('currUrl', JSON.stringify(curr_url));
    $('#subscribe_course').modal('hide');
    $('#unlock_course').modal('show');
    localStorage.setItem('closePromotionModal', 'true');
  }
  closeThis(){
    localStorage.setItem('closePromotionModal', 'true');
  }

  onSubmit() {
    this.submitted =true;
    console.log(this.contactUsForm.valid);
    if (this.contactUsForm.invalid) {
      return;
    } else {
      this.regBtn = true;
      $('#career_btn').html('please wait...');
      //console.log(this.registerForm.value); return false;
      this.userService.contactUs(this.contactUsForm.value)
        .subscribe((response: any) => {
          if (response.state === 200) {
           // console.log(response.data);
           this.isMsg = false;
           this.regBtn = false;
            this.contactUs_message = '<div class="alert alert-success">Request Sent Successfully.</div>';
            this.contactUsForm.reset();
            this.contactUsForm.controls['name'].setErrors(null);
            this.contactUsForm.controls['email'].setErrors(null);
            this.contactUsForm.controls['mobile'].setErrors(null);
            this.contactUsForm.controls['subject'].setErrors(null);
            this.contactUsForm.controls['course'].setErrors(null);
            
            setTimeout(() => {
              this.contactUs_message = '';
              this.isMsg = true;
            },10000)
           // $('#appJobForm').modal('hide');
         } else {
            this.contactUs_message = '<div class="alert alert-danger">'+response.msg+'</div>';
          }

          this.regBtn = false;
          $('#career_btn').html('Apply');
          this.isMsg = false;
      });
    }
  }

  numberOnly(event): boolean {
    if(isNaN(event.key)) {
      return false;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!((charCode >= 48 && charCode  <= 57) || (charCode >= 96 && charCode <= 105))) {
      return false;
    }
    return true;

  }

  onChangeCourse(event) {

  }

  onChangeBranch(event) {

  }

}
